const ITEMS = [
  "Gestion des ressources humaines",
  "Comptabilité & Paie",
  "Informatisation",
  "Assistance fiscale",
  "Boussole de la Paie CI",
  "Yopougon — Abidjan",
];

function Row({ hidden }) {
  return (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="whitespace-nowrap px-7 font-display text-base font-semibold uppercase tracking-[0.18em] text-korban-gold sm:text-lg">
            {item}
          </span>
          <span className="h-2 w-2 rotate-45 bg-korban-blue" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="marquee-paused overflow-hidden border-y border-korban-gold/20 bg-korban-navy2/40 py-5" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
